import { isPlatformBrowser } from "@angular/common";
import { EventEmitter, Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Observable, ReplaySubject, Subject } from "rxjs";
import { cloneDeep, random } from "lodash-es";
import { GlobalConfig, ToastrService } from "ngx-toastr";
import millify from "millify";
@Injectable()
export class CommonService {
    toastRef: any;
    options: GlobalConfig;
    changeLanguage: EventEmitter<any> = new EventEmitter();
    hiddenLang: EventEmitter<any> = new EventEmitter();
    changeFlag: EventEmitter<any> = new EventEmitter();
    closeDiscount: EventEmitter<any> = new EventEmitter();
    animateStage: EventEmitter<any> = new EventEmitter();
    availableLanguages:any=['en','es','pt'];
    constructor(@Inject(PLATFORM_ID) private platformId: Object,
        private toastr: ToastrService) {

    }

    setTheme(themeName: any) {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('theme', themeName);
            document.documentElement.className = themeName;
        }
    }

    getTheme() {
        if (isPlatformBrowser(this.platformId)) {
            return localStorage.getItem('theme');
        }
        return 'es'; // Add a default return value
    }

    toTitleCase = (phrase: any) => {
        if (phrase) {
            return phrase
                .toLowerCase()
                .split(' ')
                .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        }
    };

    public setLanguage(lng: any) {
        if (isPlatformBrowser(this.platformId)) {
            let lang = (lng == 'undefined') ? 'en' : lng;
            localStorage.setItem('language', lang);
        }
    }

    public getLanguage(): string {
        if (isPlatformBrowser(this.platformId)) {
            const language = localStorage.getItem('language');
            if (language && this.availableLanguages.includes(language)) {
                return language;
            }
        }
        return 'en'; // Valor por defecto si no es un navegador o si el idioma no está disponible
    }
    
    public getFlag() {
        if (isPlatformBrowser(this.platformId)) {
            const flag = localStorage.getItem('flag');
            return flag ? flag : ('en');
        }
        return 'en'; // Valor por defecto si no es un navegador
    }

    public setFlag(flg: any) {
        if (isPlatformBrowser(this.platformId)) {
            let flag = (flg == 'undefined') ? 'en' : flg;
            localStorage.setItem('flag', flag);
        }
    }

    showToastMessage(messages: string, time: number, status: number) {
        let notificationStatus: String = "200";
        let notificationTitle: string = "";
        if (status == 100) {
            notificationStatus = "border-blue";
            notificationTitle = "Info";
        }
        if (status == 200) {
            notificationStatus = "border-green";
            notificationTitle = "Success";
        }
        if (status == 400) {
            notificationStatus = "border-red";
            notificationTitle = "Error";
        }
        const opt = cloneDeep(this.options);
        const { message, title } = { message: messages, title: notificationTitle };
        this.toastRef = this.toastr.show(message, title, {
            timeOut: time,
            toastClass: "toast " + notificationStatus,
            positionClass: 'toast-top-right',
            enableHtml: true,
            progressBar: true
        });
    }

    getHumanValue(value) {
        return millify(value, {
            units: ["", "K", "M", "B", "T"], // Unidades para valores monetarios
            space: true,
            precision: 2 // Precisión de dos decimales
        });
    }
}
